export default "__VITE_ASSET__BrZhKlO5__"